import React from 'react';
import { BarChart, Bar, CartesianGrid, XAxis, YAxis, ReferenceLine, ResponsiveContainer } from 'recharts';


const WaterLevelGauge = ({
  minOnRecord,
  typicalRangeLow,
  typicalRangeHigh,
  maxOnRecord,
  currentValue,
  forecastValue,
  gaugeLabel
}) => {
	
	let absolutes = {
		name: gaugeLabel || "Measurement",
		// "Maximum on Record": maxOnRecord,
		// "Typical Maximum": typicalRangeHigh,
		// "Typical Minimum": typicalRangeLow < 0 ? 0 : typicalRangeLow,
		// "Minimum on Record": minOnRecord < 0 ? null : minOnRecord,
		"Current Value": currentValue
	}
	// // Correct to make these absolute
	// if(minOnRecord > 0) {
	// 	absolutes["Maximum on Record"] = absolutes["Maximum on Record"] - minOnRecord;
	// 	absolutes["Typical Maximum"] = absolutes["Typical Maximum"] - minOnRecord;
	// 	absolutes["Typical Minimum"] = absolutes["Typical Minimum"] - minOnRecord;
	// }
	// if(typicalRangeLow > 0) {
	// 	absolutes["Maximum on Record"] = absolutes["Maximum on Record"] - typicalRangeLow;
	// 	absolutes["Typical Maximum"] = absolutes["Typical Maximum"] - typicalRangeLow;
	// }
	// absolutes["Maximum on Record"] = absolutes["Maximum on Record"] - typicalRangeHigh;

	let runningTotal = 0;

	// Minimum on Record
	if(minOnRecord > 0) {
		absolutes["Minimum on Record"] = parseFloat(minOnRecord);
	} else {
		absolutes["Minimum on Record"] = 0;
	}
	runningTotal = runningTotal + absolutes["Minimum on Record"];

	// Typical Minimum
	if(typicalRangeLow > 0) {
		absolutes["Typical Minimum"] = parseFloat(typicalRangeLow)-runningTotal;
	} else {
		absolutes["Typical Minimum"] = 0;
	}
	runningTotal = runningTotal + absolutes["Typical Minimum"];

	// Typical Maximum
	if(typicalRangeHigh > 0) {
		absolutes["Typical Maximum"] = parseFloat(typicalRangeHigh) - runningTotal;
	} else {
		absolutes["Typical Maximum"] = 0;
	}
	runningTotal = runningTotal + absolutes["Typical Maximum"];

	// Maximum on Record
	if(maxOnRecord > 0) {
		absolutes["Maximum on Record"] = parseFloat(maxOnRecord) - runningTotal;
	} else {
		absolutes["Maximum on Record"] = 0;
	}
	runningTotal = runningTotal + absolutes["Maximum on Record"];

	let domain = ["auto", "auto"];
	let isBrokenAxis = false;
	if((parseFloat(minOnRecord) > 25 || parseFloat(typicalRangeLow) > 25) && parseFloat(currentValue) > typicalRangeLow) {
		domain = [typicalRangeLow*0.93, 'auto'];
		isBrokenAxis = true;
	}
	
	let barData = [absolutes];

	  return <ResponsiveContainer width="100%" height="100%">
		  <BarChart data={barData} width="100" height="100">
		  	<XAxis dataKey="name" />
		    <YAxis domain={domain} allowDataOverflow />
		    {runningTotal > 0 ? [
			    <Bar dataKey="Minimum on Record" fill="#8B4513" stackId="a" key="wg_min" />,
			    <Bar dataKey="Typical Minimum" fill="#d7c0a2" stackId="a" key="wg_typ_min" />,
			    <Bar dataKey="Typical Maximum" fill="#C1E1C1" stackId="a" key="wg_typ_max" />,
			    <Bar dataKey="Maximum on Record" fill="#ff6961" stackId="a" key="wg_max" />
			  ] : null}
		    <Bar dataKey="Current Value" fill="#A7C7E7" stackId="b" />
		   	<CartesianGrid />

		   {/*<ReferenceLine y={typicalRangeHigh} label={null} stroke={"black"} strokeDasharray="3 3" />
		   <ReferenceLine y={typicalRangeLow} label={null} stroke={"black"} strokeDasharray="3 3" />*/}
		   <ReferenceLine y={currentValue} label={null} stroke={"blue"} isAnimationActive={false} />
		   {forecastValue && <ReferenceLine y={forecastValue} label={null} stroke={"black"} isAnimationActive={false} strokeDasharray="2 2" />}
		  </BarChart>
	</ResponsiveContainer>;
};

export default WaterLevelGauge;